import { jsx as _jsx } from "react/jsx-runtime";
import { TextTrim } from '../system/text-trim';
export function Badge({ children, tone = 'primary', style, }) {
    const bg = tone === 'mute' ? 'var(--accent)' : 'var(--primary)';
    const fg = tone === 'mute' ? 'var(--foreground)' : 'var(--background)';
    return (_jsx("span", { style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: bg,
            borderRadius: 'var(--radius-full)',
            height: 'var(--space-lg)',
            padding: '0 var(--space-sm)',
            font: 'var(--type-label-sm)',
            color: fg,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            ...style,
        }, children: _jsx(TextTrim, { children: children }) }));
}
//# sourceMappingURL=Badge.js.map